import * as React from "react";
import Svg from "./StyledSvg";
type Props = {
  size?: "XS" | "S" | "M" | "L" | "XL" | "XXL";
  color?: string;
  style?: object;
};

interface SizeData {
    size: number;
    stroke: number;
  }

  interface AvailableSizes {
    XS: SizeData;
    S: SizeData;
    M: SizeData;
    L: SizeData;
    XL: SizeData;
    XXL: SizeData;
  }
  ;
const availableSizes: AvailableSizes = {"XS":{"size":16,"stroke":1.3},"S":{"size":20,"stroke":1.5},"M":{"size":24,"stroke":1.8},"L":{"size":40,"stroke":2.2},"XL":{"size":48,"stroke":2.5},"XXL":{"size":70,"stroke":2.8}};
function Nano({
  size = "M",
  color = "currentColor",
  style
}: Props): React.JSX.Element {
  const strokeWidth = availableSizes[size]?.stroke;
  const appliedSize = availableSizes[size]?.size;
  return <Svg width={appliedSize} height={appliedSize} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" color={color} style={style}><path vectorEffect="non-scaling-stroke" d="M17 17.9167C17 18.15 17.1833 18.3333 17.4167 18.3333C17.6417 18.3333 17.8333 18.15 17.8333 17.9167C17.8333 17.6917 17.6417 17.5 17.4167 17.5C17.1833 17.5 17 17.6917 17 17.925M8.75739 12L4.35359 7.59618C4.15833 7.40092 4.15833 7.08433 4.35359 6.88907L7.88912 3.35354C8.08438 3.15828 8.40097 3.15828 8.59623 3.35354L17.2427 12M3.43902 21H18C19.6569 21 21 19.6568 21 18C21 16.3431 19.6569 15 18 15H3.43902C3.19656 15 3 15.1965 3 15.439V20.561C3 20.8034 3.19656 21 3.43902 21Z" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" /></Svg>;
}
export default Nano;